import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI, AutoCompleteSelectUI, DatePickerUI } from '../../Interface';
import dayjs from 'dayjs';
import { ListItem } from '@mui/material';

const ComplaintReporFields = ({ viewField, autoCompleteOptions, selectedValues, autocompleteData }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  return (
    <div className="grid grid-cols-12 gap-x-4 mx-4">
      <div className="col-span-12 md:col-span-6">
        <Field
          type="text"
          name="supplier"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Gyártó" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.supplier} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.supplier && values.supplier !== '' }}
        />
        <Field
          type="autocomplete"
          name="supplierContactPersonId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Kapcsolattartó" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.supplierContactPersonId} />}
          onChange={(_e, newVal) => {
            setFieldValue('supplierContactPersonId', newVal?.value ?? null).then(() => {
              validateField('supplierContactPersonId');
            });
            const findedR1 = autocompleteData?.resourceOne?.find((r1) => r1.id === newVal?.value);

            if (findedR1) {
              setFieldValue('supplierEmail', findedR1.email);
              setFieldValue('supplierPhoneNumber', findedR1.phoneNumber);
            } else {
              setFieldValue('supplierEmail', '');
              setFieldValue('supplierPhoneNumber', '');
            }
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.supplierContactPersonId !== '' }}
          selectedValue={values.supplierContactPersonId}
          selectedLabelValue={selectedValues?.contactPerson?.name}
          dataset={autoCompleteOptions?.resourceOne}
        />
        <Field
          type="text"
          name="supplierEmail"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Email" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.supplierEmail} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.supplierEmail && values.supplierEmail !== '' }}
        />
        <Field
          type="text"
          name="supplierPhoneNumber"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Telefonszám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.supplierPhoneNumber} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.supplierPhoneNumber && values.supplierPhoneNumber !== '' }}
        />
        <Field
          type="autocomplete"
          name="supplierComplaintId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Reklamáció azonosító" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.supplierComplaintId} />}
          onChange={(_e, newVal) => {
            setFieldValue('supplierComplaintId', newVal?.value ?? null).then(() => {
              validateField('supplierComplaintId');
            });

            const findedComplaint = autocompleteData?.complaints?.find((c) => c.id === newVal?.value);

            if (findedComplaint) {
              setFieldValue('itemCode', findedComplaint.itemCode);
              setFieldValue('supplierComplaintDate', dayjs(findedComplaint.date));
              setFieldValue('customerComplaintDate', dayjs(findedComplaint.date));
              setFieldValue('companyId', findedComplaint.companyId);
              setFieldValue('issueDescription', findedComplaint.description);
              setFieldValue('rejectedQty', findedComplaint.quantity);
            } else {
              setFieldValue('itemCode', '');
              setFieldValue('supplierComplaintDate', null);
              setFieldValue('customerComplaintDate', null);
              setFieldValue('companyId', null);
              setFieldValue('issueDescription', '');
              setFieldValue('rejectedQty', '');
            }
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.supplierComplaintId !== '' }}
          selectedValue={values.supplierComplaintId}
          selectedLabelValue={selectedValues?.complaint?.reference}
          renderOption={(props, option) => <ListItem {...props}>{option.fullLabel}</ListItem>}
          dataset={autoCompleteOptions?.complaints}
        />
        <Field
          type="text"
          name="itemCode"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Rajzszám/Cikkszám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.itemCode} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.itemCode && values.itemCode !== '' }}
        />
        <Field
          type="date"
          name="supplierComplaintDate"
          component={DatePickerUI}
          value={values.supplierComplaintDate}
          fullWidth
          label={<FormLabelUI text="Reklamáció dátuma" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.supplierComplaintDate} />}
          onChange={(date) => {
            setFieldValue('supplierComplaintDate', date).then(() => {
              validateField('supplierComplaintDate');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.supplierComplaintDate !== '' }}
        />
      </div>
      <div className="col-span-12 md:col-span-6">
        <Field
          type="autocomplete"
          name="companyId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Vevő" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.companyId} />}
          onChange={(_e, newVal) => {
            setFieldValue('companyId', newVal?.value ?? null).then(() => {
              validateField('companyId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.companyId !== '' }}
          selectedValue={values.companyId}
          selectedLabelValue={selectedValues?.company?.name}
          dataset={autoCompleteOptions?.company}
        />
        <Field
          type="text"
          name="customerContactPerson"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Kapcsolattartó" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.customerContactPerson} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.customerContactPerson && values.customerContactPerson !== '' }}
        />
        <Field
          type="text"
          name="customerEmail"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Email" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.customerEmail} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.customerEmail && values.customerEmail !== '' }}
        />
        <Field
          type="text"
          name="customerPhoneNumber"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Telefonszám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.customerPhoneNumber} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.customerPhoneNumber && values.customerPhoneNumber !== '' }}
        />
        <Field
          type="text"
          name="customerComplaintId"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Reklamáció azonosító" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.customerComplaintId} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.customerComplaintId && values.customerComplaintId !== '' }}
        />
        <Field
          type="date"
          name="customerComplaintDate"
          component={DatePickerUI}
          value={values.customerComplaintDate}
          fullWidth
          label={<FormLabelUI text="Reklamáció dátuma" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.customerComplaintDate} />}
          onChange={(date) => {
            setFieldValue('customerComplaintDate', date).then(() => {
              validateField('customerComplaintDate');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.customerComplaintDate !== '' }}
        />
      </div>
      <div className="col-span-12">
        <Field
          type="text"
          name="other"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Egyéb" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.other} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.other && values.other !== '' }}
        />
      </div>
    </div>
  );
};

export default ComplaintReporFields;
